import { useContext, useEffect, useMemo, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { AuthContext } from "./auth/AuthProvider";
import "./style/Navbar.css";

function Navbar() {
  const { user, googleUser, userLogout, payed, loading } =
    useContext(AuthContext);

  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // ✅ close menu on route change
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  // ✅ displayName MUST be in render scope (NOT inside useEffect)
  const displayName = useMemo(() => {
    return (
      googleUser?.name ||
      googleUser?.username ||
      googleUser?.email ||
      user?.username ||
      user?.email ||
      ""
    );
  }, [googleUser, user]);

  const isLoggedIn = !!(googleUser || user);

  return (
    <>
      <header className="site-header">
        <div className="container nav-wrap">
          <a href="/" className="brand">
            Introspecta<span style={{ color: "#c8a870" }}>.</span>
            {/* <img src="/logo.png" className="logoIntrospecta" alt="logo" /> */}
          </a>

          {windowWidth < 1300 ? (
            <div className="navbar-parent">
              {!isOpen && (
                <button
                  id="hamburger1"
                  className="hamburger"
                  type="button"
                  onClick={() => setIsOpen(true)}
                  aria-label="Open menu"
                >
                  ☰
                </button>
              )}
            </div>
          ) : (
            <div>
              <>
                <a href="/" className="nav-link">
                  Home
                </a>
                <a href="/about" className="nav-link">
                  About
                </a>
                {/* <NavLink to="/mission" className="nav-link">
                  Our Mission
                </NavLink> */}
                <a href="/contact" className="nav-link">
                  Contact
                </a>
                <a href="/pricing" className="nav-link">
                  Pricing Plan
                </a>
                <a href="/faq" className="nav-link">
                  FAQ
                </a>
                <a href="/billing-refunds" className="nav-link">
                  Billing & Refunds
                </a>

                {/* ✅ Use Link, not <a href> */}
                {/* <Link to="/session" className="bookSession">
                  <button
                    className="btn primary btnHome"
                    id="primary1"
                    type="button"
                    style={{ color: "white" }}
                  >
                    {payed ? "Go to My Session" : "Explore Themes →"}
                  </button>
                </Link> */}

                {isLoggedIn ? (
                  <button
                    id="logoutBtn"
                    className="btn outline small"
                    type="button"
                    onClick={() => userLogout()}
                  >
                    Log Out
                  </button>
                ) : (
                  <>
                    <Link
                      to="/login"
                      id="loginBtn"
                      className="nav-link"
                      // style={{ color: "black" }}
                    >
                      <button className="btn outline small" type="button">
                        Log In
                      </button>
                    </Link>

                    <Link to="/signup" id="signupBtn" className="nav-link">
                      <button className="btn outline small" type="button">
                        Sign Up
                      </button>
                    </Link>
                  </>
                )}
              </>
            </div>
          )}
        </div>
      </header>

      {windowWidth < 1300 && (
        <nav className={`sidebar ${isOpen ? "open" : "closed"}`}>
          <button
            id="close-btn"
            className="close-btn"
            type="button"
            onClick={() => setIsOpen(false)}
            aria-label="Close menu"
            style={{
              backgroundColor: "transparent",
            }}
          >
            X
          </button>

          {/* ✅ Optional loading indicator */}
          {loading && (
            <p style={{ textAlign: "center", opacity: 0.7, marginTop: "10px" }}>
              Checking session...
            </p>
          )}

          {/* ✅ Greeting */}
          {isLoggedIn && (
            <>
              <p
                className="sidebar-par"
                style={{
                  fontSize: "20px",
                  textAlign: "center",
                  marginBottom: "0",
                  fontWeight: "900",
                  fontStyle: "italic",
                  color: "#c7a36a",
                  fontFamily: "fangsong",
                }}
              >
                HI,
              </p>

              <div className="sidebar-par" style={{ textAlign: "center" }}>
                <span
                  className="userName"
                  style={{
                    fontSize: "26px",
                    fontWeight: "900",
                    color: "#c7a36a",
                    fontFamily: "fangsong",
                  }}
                >
                  {displayName}
                </span>
              </div>
            </>
          )}

          <a href="/" className="nav-link">
            Home
          </a>
          <a href="/about" className="nav-link">
            About
          </a>
          {/* <NavLink to="/mission" className="nav-link">
                  Our Mission
                </NavLink> */}
          <a href="/contact" className="nav-link">
            Contact
          </a>
          <a href="/pricing" className="nav-link">
            Pricing Plan
          </a>
          <a href="/faq" className="nav-link">
            FAQ
          </a>
          <a href="/billing-refunds" className="nav-link">
            Billing & Refunds
          </a>

          {/* ✅ Use Link, not <a href> */}
          <a href="/session" className="bookSession">
            <button
              // className="btn-dark-primary"
              className="btn primary btnHome"
              id="primary1"
              type="button"
              // style={{ color: "white" }}
            >
              {payed ? "Go to My Session" : "Explore Themes →"}
            </button>
          </a>

          {isLoggedIn ? (
            <button
              className="btn outline small"
              type="button"
              onClick={() => userLogout()}
              id="sidebarLogout"
            >
              Log Out
            </button>
          ) : (
            <>
              <Link to="/login" className="nav-link">
                <button
                  className="btn outline small"
                  type="button"
                  id="sidebarLogin"
                >
                  Log In
                </button>
              </Link>

              <Link to="/signup" className="nav-link">
                <button
                  className="btn outline small"
                  type="button"
                  id="sidebarSignup"
                >
                  Sign Up
                </button>
              </Link>
            </>
          )}
        </nav>
      )}
    </>
  );
}

export default Navbar;
